import * as React from "react";

export default function CompactIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="49"
      height="49"
      viewBox="0 0 49 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <rect
        x="0.666992"
        y="0.746216"
        width="48"
        height="47.9999"
        rx="7.92"
        fill="#CCF0F0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.4662 35.5462H15.0662C14.4038 35.5462 13.8662 35.0086 13.8662 34.3462V27.1462C13.8662 26.4838 14.4038 25.9462 15.0662 25.9462H17.4662C18.1286 25.9462 18.6662 26.4838 18.6662 27.1462V34.3462C18.6662 35.0086 18.1286 35.5462 17.4662 35.5462Z"
        stroke="#109494"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.866 30.7462H28.6656C29.1852 30.7462 29.6904 30.5782 30.1056 30.2662L33.0048 28.0918C33.7284 27.5494 34.7412 27.6214 35.3808 28.261V28.261C36.0912 28.9714 36.0912 30.1222 35.3808 30.8314L32.8932 33.319C32.2236 33.9886 31.3692 34.4458 30.4404 34.6318L26.9244 35.335C26.2272 35.4742 25.5084 35.4574 24.8184 35.2846L21.6384 34.4902C21.258 34.3942 20.868 34.3462 20.4756 34.3462H18.666"
        stroke="#109494"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.866 30.7462H27.648C28.6524 30.7462 29.466 29.9326 29.466 28.9282V28.5646C29.466 27.7306 28.8984 27.0034 28.0896 26.8018L25.3392 26.1142C24.8916 26.0026 24.4332 25.9462 23.9724 25.9462V25.9462C22.86 25.9462 21.7716 26.275 20.8464 26.893L18.666 28.3462"
        stroke="#109494"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.7334 22.3462H31.4004C32.3204 22.3462 33.0664 21.7867 33.0664 21.0959V17.5964C33.0664 16.9057 32.3204 16.3462 31.3994 16.3462H22.7324C21.8124 16.3462 21.0664 16.9057 21.0664 17.5964V21.0967C21.0664 21.7867 21.8124 22.3462 22.7334 22.3462Z"
        stroke="#109494"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
